import React from 'react';
import {Button} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface NewEmployeeActionButtonComponentProps {
    selected: number[];
    fullWidth?: boolean;
    handleActivate: () => void;
    handleDeactivate: () => void;
    handleBulkDelete: () => void;
}

const NewEmployeeActionButtonComponent: React.FC<NewEmployeeActionButtonComponentProps> = ({
                                                                                               selected,
                                                                                               fullWidth,
                                                                                               handleActivate,
                                                                                               handleDeactivate,
                                                                                               handleBulkDelete
                                                                                           }) => {
    const {t} = useTranslation();

    return (
        <>
            <Button
                variant="contained"
                fullWidth={fullWidth}
                color="success"
                onClick={handleActivate}
                disabled={selected.length === 0}
            >
                {t('employee.actions.activate')}
            </Button>
            <Button
                variant="contained"
                fullWidth={fullWidth}
                color="warning"
                onClick={handleDeactivate}
                disabled={selected.length === 0}
            >
                {t('employee.actions.deactivate')}
            </Button>
        </>
    );

};

export default NewEmployeeActionButtonComponent;